function asView(buf) {
    if (buf instanceof ArrayBuffer) {
        return new Uint8Array(buf);
    }
    return buf;
}
export function getSingleBufferFromArray(raw) {
    if (raw instanceof ArrayBuffer || ArrayBuffer.isView(raw)) {
        return asView(raw);
    }
    if (!Array.isArray(raw) || raw.length === 0) {
        return undefined;
    }
    const first = raw[0];
    if (first === undefined ||
        first === null ||
        (!(first instanceof ArrayBuffer) && !ArrayBuffer.isView(first))) {
        return undefined;
    }
    if (raw.length === 1) {
        return asView(first);
    }
    const views = raw.filter((item) => item != null && (item instanceof ArrayBuffer || ArrayBuffer.isView(item)));
    if (views.length === 0)
        return undefined;
    const totalLength = views.reduce((sum, v) => sum +
        (v instanceof ArrayBuffer
            ? v.byteLength
            : v.byteLength), 0);
    const out = new Uint8Array(totalLength);
    let offset = 0;
    for (const v of views) {
        const view = asView(v);
        out.set(new Uint8Array(view.buffer, view.byteOffset, view.byteLength), offset);
        offset += view.byteLength;
    }
    return out;
}
